export enum TypesConsolidationData {
  SCORE_INADIMPLENCIA = 'score_inadimplencia',
  SCORE_PEDAGOGICO_ALUNOS = 'score_pedagogico_alunos',
  SCORE_FINANCEIRO_GERAL = 'score_financeiro_geral',
  SCORE_FREQUENCIA_ALUNOS = 'score_frequencia_alunos',
  SCORE_FLUXO_CAIXA = 'score_fluxo_caixa',
  SCORE_GERAL_ALUNOS = 'score_geral_alunos',
  SCORE_FATURAMENTO = 'score_faturamento',
  SCORE_MOVIMENTACAO_ESCOLAR = 'score_movimentacao_escolar',
  SCORE_INADIMPLENCIA_EVOLUCAO = 'score_comparativo_inadimplencia',
  SCORE_INADIMPLENCIA_ACUMULO = 'score_acumulo_inadimplencia',
  SCORE_INADIMPLENCIA_ACUMULO_EVOLUCAO = 'score_evolucao_inadimplencia',
  SCORE_INADIMPLENCIA_EXPIRACAO = 'score_inadimplencia_expiracao',
  SCORE_CONTAS_RECEBIDAS_ATRASO = 'superavit_defasagem',
  SCORE_IPCA_ENTRADA_SAIDA_ALUNOS = 'ipca_poor_ano_entrada_saida',
}
